import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import { Box, Button, Center, Flex, Select, Spinner, Text } from '@chakra-ui/react'
import { useMemo, useState } from 'react'
import { Card } from './Card'
import InputFloating from '../../../components/InputFloating'
import { useDebounce } from '../../../hooks/useDebounce'
import { baseURL } from '../../../services/api'
import { useQuery } from 'react-query'

export function ConsultaEstoque() {
  const [searchProduct, setSearchProduct] = useState('')
  const [searchCategory, setSearchCategory] = useState('')
  const debouncedSearchTerm = useDebounce(searchProduct, 500)
  const [estoque, setEstoque] = useState('interno')

  const url = estoque === 'interno' ? `/pedido/listar-estoque-interno` : `/pedido/listar-todos-ultra-rapido`

  const { data: queryData, isLoading } = useQuery(
    ['getItens', url],
    async () => {
      const response = await baseURL.get(url)

      return response.data
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 10, // 10 minutos
    }
  )

  const catList = queryData
    ?.map((item) => {
      return item.categoria
    })
    .filter((item, index, self) => {
      return self.indexOf(item) === index
    })

  function handleStock(e) {
    setEstoque(e.target.value)
    console.log('estoque', e.target.value)
  }

  const filteredData = useMemo(() => {
    if (!queryData) {
      return []
    }

    if (debouncedSearchTerm !== '') {
      return queryData.filter((item) => item?.name?.toLowerCase().includes(debouncedSearchTerm.toLowerCase()))
    } else if (searchCategory !== '') {
      return queryData.filter((item) => item?.categoria?.toLowerCase().includes(searchCategory.toLowerCase()))
    } else {
      return queryData
    }
  }, [queryData, debouncedSearchTerm, searchCategory])

  return (
    <>
      <HeadingPages name="Consulta de Estoque" />

      <Flex w="100%" alignItems="center" justifyContent="center" flexDir={'column'} gap={2}>
        <Text as={'h1'} fontSize="2xl" fontWeight="bold" color="gray.500" textTransform="uppercase" textAlign="center">
          Selecione
        </Text>

        <Flex gap={5}>
          <Button
            bgColor={'#68C318'}
            color={'#fff'}
            _hover={{
              filter: 'brightness(0.9)',
            }}
            value={'interno'}
            w="150px"
            onClick={(e) => handleStock(e)}
          >
            Estoque interno
          </Button>
          <Button
            bgColor={'#FD712F'}
            color={'#fff'}
            _hover={{
              filter: 'brightness(0.9)',
            }}
            w="150px"
            value={'umdia'}
            onClick={(e) => handleStock(e)}
          >
            Produtos de 1 dia
          </Button>
        </Flex>
      </Flex>
      <Box maxW="1150px" mx="auto" mt="4" p="6" w="100%" display="grid" gridTemplateColumns="repeat(2, 1fr)" gridGap="4" bg="white">
        <Flex>
          <InputFloating label="Produto" bgColor={'transparent'} onChange={(e) => setSearchProduct(e.target.value)} />
          <Select disabled={isLoading} placeholder="Categoria" size="md" w="100%" ml="2" onChange={(e) => setSearchCategory(e.target.value)}>
            <option value="">Todas</option>
            {catList?.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </Select>
        </Flex>

        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Text fontSize="sm" color="gray.500" fontWeight="bold" alignSelf="center">
            Você está vendo o estoque {estoque === 'interno' ? 'Interno' : '1 dia'}
          </Text>
          <Text fontSize="sm" color="gray.500" fontWeight="bold">
            {queryData?.length} produtos encontrados
          </Text>
        </Box>
      </Box>
      <Box maxW="1200px" mx="auto" mt="4" p="6" pb="4" w="100%" display="grid" gridTemplateColumns="repeat(4, 1fr)" gridGap="4">
        {filteredData?.map((item, index) => (
          <Card key={index} item={item} />
        ))}
      </Box>
      <Center>
        <Text>
          {isLoading && (
            <Flex alignItems="center" justifyContent="center" marginBlock={'1rem'}>
              <Spinner />
              <Text ml="2">Carregando...</Text>
            </Flex>
          )}
        </Text>
      </Center>
      {/* {limiter >= queryData?.length && (
        <Center>
          <Text fontSize="sm" color="gray.500" fontWeight="bold" mb={'1rem'}>
            Não há mais produtos para carregar
          </Text>
        </Center>
      )} */}
    </>
  )
}
